import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'

export const StyledWorkshopCard = styled.div`
  background: #ffffff;
  border-radius: ${theme.borderRadius};

  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04))
    drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.06))
    drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.04));
`
type StyledCardHeadingProps = {
  banner: string
}
export const StyledCardHeading = styled.div<StyledCardHeadingProps>`
  width: 100%;
  height: 400px;
  background-image: url('${(props: StyledCardHeadingProps) => props.banner}');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;

  ${MediaQueries.mbUp} {
    padding: 40px 21px 40px 24px;
  }

  ${MediaQueries.mbDown} {
    padding: 32px 16px;
  }
`
export const StyledCardBody = styled.div`
  ${MediaQueries.mbUp} {
    padding: 16px 21px 40px 21px;
  }

  ${MediaQueries.mbDown} {
    padding: 16px 16px 32px 16px;
  }
`

export const StyledWorkshopInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyledWorkshopIcon = styled.img`
  width: 20px;
  height: 20px;
`

export const StyledWorkshopDateText = styled.p`
  display: -webkit-box;
  overflow: hidden;
  margin-top: 4px;
  -webkit-box-orient: vertical;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.2px;
  -webkit-line-clamp: 1;
  line-height: 32px;
`

type StyledSubscribeButtonProps = {
  disabled?: boolean
}
export const StyledSubscribeButton = styled.div<StyledSubscribeButtonProps>`
  width: fit-content;
  padding: 9px 24px;
  margin: 24px auto 0 auto;
  background: ${theme.colors.primaryBase};
  border-radius: ${theme.borderRadius};
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;

  ${(props) =>
    props.disabled &&
    `background: ${theme.colors.neutral700};
      pointer-events: none;
      cursor: not-allowed;`}
`

export const StyledWorkshopLocationText = styled.a`
  display: -webkit-box;
  overflow: hidden;
  margin-top: 4px;
  -webkit-box-orient: vertical;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.2px;
  -webkit-line-clamp: 1;
  line-height: 32px;
  text-decoration: none;
  &[href] {
    color: ${theme.colors.primaryBase};
  }
`
